import axiosClient from "@/utils/axios-client";
import { toCamelKeyObject } from "@/utils/case";
import { ParseBusinessRegistrationCertificateResponse } from "@/shared/api/business-registration-certificate/types";
import { businessRegistrationCertificateUrl } from "@/shared/api/business-registration-certificate/url";

export const businessRegistrationCertificateMutationApi = {
  // 사업자등록증 파일 업로드 → 저장 후 OCR 파싱 결과 반환.
  // multipart/form-data 의 file 하나만 받는다(필수).
  // 파싱 결과를 바로 쓰는 게 목적이라 AxiosResponse가 아니라 camel로 변환한 data만 돌려준다.
  parseBusinessRegistrationCertificate: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await axiosClient.post(
      businessRegistrationCertificateUrl.root(),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return toCamelKeyObject(
      data
    ) as ParseBusinessRegistrationCertificateResponse;
  },
};
